import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'appTime'
})
export class AppTimePipe implements PipeTransform {
    transform(value: string, args?: any): string {
        if (!value) return '';

        const parts = value.split(':');

        return `${parts[0]}:${parts[1]}`;
    }
}
